import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import NewsComp from '../components/News'
import { InfoContainer3, InfoWrapper3, TextImageSection, TextBlock, ImageBlock } from '../components/InfoSection/InfoElements'

import img from '../images/nowe/dowolnie(3).png';

const News = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

  return (
    <>
    <Navbar toggle={toggle} />
    <Sidebar isOpen={isOpen} toggle={toggle} />
    <InfoContainer3 lightBg='true'>
    <InfoWrapper3>
    <div>
      <TextImageSection>
                <TextBlock>
      <p>🌿To miejsce stworzyłam dla Ciebie jako przestrzeń zatrzymania i refleksji. Znajdziesz tu artykuły, opowieści i symbole, które mogą Cię wesprzeć na drodze przejścia przez trudne chwile i pomóc spojrzeć na nie z innej perspektywy.</p>
      <p>💜Podzielę się tutaj znaczeniem roślin, kamieni i rytuałów, które mogą nadać ceremonii i codzienności głębszy wymiar. Opowiem historie rodzin i osób, którym towarzyszyłam przy pożegnaniach – abyś mógł zobaczyć, jak różnorodne i piękne mogą być ceremonie pamięci życia. Znajdziesz też moje refleksje o pamięci, o rytuałach, o tym, co znaczy być dobrym mistrzem ceremonii.</p>
      <p>✨To także przestrzeń, gdzie gromadzę ślady mojej obecności w mediach – podcasty, wywiady, artykuły – abyś mogła/mógł lepiej poznać moje podejście i filozofię pracy. Mam nadzieję, że te treści będą dla Ciebie inspiracją i wsparciem – niezależnie od tego, na jakim etapie swojej drogi jesteś. </p>

                </TextBlock>
                <ImageBlock>
                    <img src={img} alt="Atenida" />
                </ImageBlock>
    </TextImageSection>
    </div>
    </InfoWrapper3>
    </InfoContainer3>
    <NewsComp />
    <Footer />
    </>
  )
}

export default News